export const restoreData = (payload?: any) => ({
    type: "@saga/RESTORE_DATA",
    payload
});

